// import devConfig from '../../config/dev.env.js'
// import prodConfig from '../../config/prod.env.js'
import { getAPIUrl } from "./util";

const env = process.env.NODE_ENV;
let localEnv;

// 环境切换修改此处  (仅在本地(port == "8110")时会启用)
if (location.port === "8110") {
  /***** 以下切换HOST ****/
  // 开发环境
  // localEnv = "dev";
  // 测试环境gs
  localEnv = "gs";
  // 测试环境ap
  // localEnv = 'ap'
  // 金太阳sit
  // localEnv = "sit";
  // 金太阳演示环境
  // localEnv = "iac";
  // 金太阳生产环境
  // localEnv = "sun";
  // 华煦生产环境
  // localEnv = "huaxu";
  // 外贸生产环境
  // localEnv = "trade";
  // 外贸预生产环境
  // localEnv = "tradePre";
  // 长青生产环境
  // localEnv = "changqing";
  // 万友生产环境
  // localEnv = "wanyou";
  // 国贸生产环境
  // localEnv = "guomao";
  // 幸福里生产环境
  // localEnv = "xingfuli";
  // 静馨家园生产环境
  // localEnv = "jingxinjiayuan";
}

const locationHref = window.location.href;
// const virtuaDirectory = `sun/`; // 默认为空，根据后端进行配置。
const isDev = locationHref.indexOf("dev.") > -1 || localEnv === "dev";
const isGoldenSun = locationHref.indexOf(".gs.") > -1 || localEnv === "gs";
const isSit = locationHref.indexOf("sit") > -1 || localEnv === "sit";
const isProductionIac =
  locationHref.indexOf(".iac.") > -1 || localEnv === "iac";
const isProductionGoldenSun = localEnv === "sun";
const isProductionHuaxu =
  locationHref.indexOf("huaxu") > -1 || localEnv === "huaxu"; // 华煦项目
const isProductionWm =
  locationHref.indexOf("wm.h5") > -1 || localEnv === "trade"; // 外贸项目
const isPreProductionWm =
  locationHref.indexOf("wm.timi91") > -1 || localEnv === "tradePre"; // 外贸预生产项目
const isProduction_changqing =
  locationHref.indexOf("yl.fjscqyl") > -1 || localEnv === "changqing"; // 长青生产项目
const isProduction_wanyou =
  locationHref.indexOf("yl.fj-wanyou") > -1 || localEnv === "wanyou"; // 长青生产项目
const isProduction_guomao =
  locationHref.indexOf("itgcare.") > -1 || localEnv === "guomao"; // 国贸生产项目
const isProduction_xingfuli =
  locationHref.indexOf("xflylfw") > -1 || localEnv === "xingfuli"; // 幸福里生产项目
const isProduction_jingxinjiayuan =
  locationHref.indexOf("jingxinjiayuan") > -1 || localEnv === "jingxinjiayuan"; // 静馨家园生产项目
const isProduction_kysass =
  locationHref.indexOf("ky.timi91") > -1 || localEnv === "ky.timi91"; // sass生产项目
const isAp = locationHref.indexOf(".ap.") > -1 || localEnv === "ap"; // http://omp.ap.timi91.com/
let virtuaDirectory = ``; // 默认为空，根据后端进行配置。
if (isDev) {
  virtuaDirectory = "sun/";
} else if (isSit) {
  virtuaDirectory = "";
} else if (isGoldenSun) {
  virtuaDirectory = "gs/";
}

const devHost = `http://dev.api.timi91.com/${virtuaDirectory}`;
let testHost = `https://test.api.timi91.com/${virtuaDirectory}`; // 线上测试环境
const testSitHost = `https://sit.api.timi91.com/${virtuaDirectory}`; // 线上测试环境(sit)
const testApHost = `https://api.ap.timi91.com/${virtuaDirectory}`; // 线上测试环境(ap)
if (isAp) {
  testHost = testApHost;
} else if (isSit) {
  testHost = testSitHost;
}

let appConfig = "APPCONFIG";
if (isProductionIac) {
  appConfig = "APPCONFIG_IAC";
} else if (isProductionHuaxu) {
  appConfig = "APPCONFIG_HUAXU";
} else if (isProductionWm) {
  appConfig = "APPCONFIG_WM";
} else if (isPreProductionWm) {
  appConfig = "APPCONFIG_PRE_WM";
} else if (isProductionGoldenSun) {
  appConfig = "APPCONFIG";
} else if (isProduction_changqing) {
  appConfig = "APPCONFIG_CHANGQING";
} else if (isProduction_wanyou) {
  appConfig = "APPCONFIG_WANYOU";
} else if (isProduction_guomao) {
  appConfig = "APPCONFIG_GUOMAO";
} else if (isProduction_xingfuli) {
  appConfig = "APPCONFIG_XINGFULI";
} else if (isProduction_jingxinjiayuan) {
  appConfig = "APPCONFIG_JINGXINJIAYUAN";
} else if (isProduction_kysass) {
  appConfig = "APPCONFIG_KYSASS";
}
const prodHost = getAPIUrl(appConfig);
let localHost = `https://dev.api.timi91.com/${virtuaDirectory}`; // 本地测试
if (isGoldenSun) {
  localHost = `https://test.api.timi91.com/${virtuaDirectory}`;
} else if (isSit) {
  localHost = testSitHost;
} else if (isProductionIac) {
  localHost = prodHost;
} else if (isProductionHuaxu) {
  localHost = prodHost;
} else if (isProductionWm) {
  localHost = prodHost;
} else if (isPreProductionWm) {
  localHost = prodHost;
} else if (isAp) {
  localHost = testApHost;
} else if (isProductionGoldenSun) {
  localHost = prodHost;
} else if (isProduction_changqing) {
  localHost = prodHost;
} else if (isProduction_wanyou) {
  localHost = prodHost;
} else if (isProduction_guomao) {
  localHost = prodHost;
} else if (isProduction_xingfuli) {
  localHost = prodHost;
} else if (isProduction_jingxinjiayuan) {
  localHost = prodHost;
} else if (isProduction_kysass) {
  localHost = prodHost;
}
// 开发环境： npm run dev
const development = {
  host: localHost,
  qiniuUrl: localHost
};

// 打包开发环境： npm run build dev theme(可选:default,huaxu,trade)
const dev = {
  host: devHost,
  qiniuUrl: devHost
};

// 打包测试环境： npm run build test theme(可选:default,huaxu,trade)
const test = {
  host: testHost,
  qiniuUrl: testHost
};

// 打包正式环境： npm run build host(可选:dev,test,production) theme(可选:default,huaxu,trade)
const production = {
  host: prodHost,
  qiniuUrl: prodHost
};

const CONFIG = {
  development,
  dev,
  test,
  production
};
export default CONFIG[env];



// WEBPACK FOOTER //
// ./src/config/index.js